import { createRouter, createWebHistory } from 'vue-router'
import { allRoutes } from '@/core/router/routes'
import { useAuthStore } from '@/modules/services/AuthStore/stores/auth'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: allRoutes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { left: 0, top: 0 }
    }
  },
})

// Before each route evaluates...
router.beforeEach(async (routeTo, routeFrom, next) => {
  const authRequired = routeTo.matched.some(route => route.meta.authRequired)

  // Special handling for auth callback route
  if (routeTo.path === '/auth/callback') {
    return next()
  }

  // If auth isn't required for the route, just continue.
  if (!authRequired) return next()

  const authStore = useAuthStore()

  // Check if user is authenticated
  if (authStore.isAuthenticated) {
    return next()
  }

  // If not authenticated, try to load session
  try {
    const { session } = await authStore.checkSession()
    if (session) {
      return next()
    } else {
      const shouldShowSessionExpired = routeFrom.path && routeFrom.path !== '/login' && routeFrom.name !== 'Login'

      return next({
        name: 'Login',
        query: shouldShowSessionExpired ? {
          redirectFrom: routeTo.fullPath,
          sessionExpired: 'true'
        } : {
          redirectFrom: routeTo.fullPath
        }
      })
    }
  } catch (error) {
    const shouldShowSessionError = routeFrom.path && routeFrom.path !== '/login' && routeFrom.name !== 'Login'

    return next({
      name: 'Login',
      query: shouldShowSessionError ? {
        redirectFrom: routeTo.fullPath,
        sessionError: 'true'
      } : {
        redirectFrom: routeTo.fullPath
      }
    })
  }
})

export default router
